// extracted by mini-css-extract-plugin
export default {"message":"Send_Message_message__+JyWP","message__input":"Send_Message_message__input__iZzyS","message__button":"Send_Message_message__button__-5AUL"};